module.exports = __webpack_public_path__ + "static/media/delete.4e31f832.svg";